import React from "react";
import {Button, Col, Row, Table, Tag} from "antd";
import BeneficiaryInformationPanel from "components/BeneficiaryInformationPanel";
import EmptyIcon from "icons/EmptyIcon";
import BeneficiaryModal from "components/modal/BeneficiaryModal";
import {getIndustryCode, saveBeneficiary, getHongKongSourceAccountCurrency, getBeneficiaries} from "api/api";
import {
  displayError,
  displayGenericError,
  displaySuccessMessage,
  displaySuccessMessageWithSeconds
} from "common/notifications";

import {FormattedMessage} from "react-intl";
import withUseIntl from "components/withUseIntl";

import "./BeneficiariesTable.scss";
import {getBeneficiaryById, getCountryList, getNationalityList, getRelationshipCode} from "../api/api";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import BeneficiarySelectionComponent from "./BeneficiarySelectionComponent";
import {DEFAULT_PAGE_SIZE_10} from "../common/Const";
import Icon from "antd/es/icon";
import './BeneficiariesTable.scss'

class BeneficiariesTable extends React.Component {
  state = {
    expandedRowKeys: [],
    isBeneficiaryModalVisible: false,
    countries:[],
    relations:[],
    industries:[],
    nationalities:[],
    hkSourceAccountCurrency:null,
    width: '0',
  };

  componentDidMount() {
    getHongKongSourceAccountCurrency().then(res => {
      this.setState({
        hkSourceAccountCurrency:res
      })
    })
    getRelationshipCode().then(response => {
      this.setState({
        relations: response
      });
    }).catch(error => {
      displayGenericError(error);
    });
    getIndustryCode().then(response => {
      this.setState({
        industries: response
      });
    }).catch(error => {
      displayGenericError(error);
    });
    getCountryList()
      .then(response => {
        this.setState({
          countries: response
        });
      })
      .catch(error => {
        displayGenericError(error);
      });

    getNationalityList()
        .then(response => {
          this.setState({
            nationalities: response
          });
        })
        .catch(error => {
          displayGenericError(error);
        });
    
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  onRowClicked = (beneficiary, idx) => {
    let newExpandedRowKeys = this.state.expandedRowKeys;
    if (newExpandedRowKeys.includes(beneficiary.id)) {
      var index = newExpandedRowKeys.indexOf(beneficiary.id);
      if (index !== -1) {
        newExpandedRowKeys.splice(index, 1);
      }
    } else {
      newExpandedRowKeys.push(beneficiary.id);
    }
    this.setState({
      expandedRowKeys: newExpandedRowKeys
    });
  };

  submitBeneficiary = beneficiary => {
    saveBeneficiary(beneficiary)
    .then(response => {
        this.closeBeneficiaryModal();
        if (this.props.onRefresh) this.props.onRefresh();
        displaySuccessMessageWithSeconds("Successfully!", 1)
      })
      .catch(error => {
        displayGenericError(error);
      });
  };

  onAddBeneficiaryClicked = () => {
    this.setState({
      selectedBeneficiary:null,
      isBeneficiaryModalVisible: true
    });
  };

  closeBeneficiaryModal = () => {
    this.setState({
      isBeneficiaryModalVisible: false
    });
  };

  editBeneficiaryClicked = (beneficiaryId) => {
    let countries = this.state.countries;
    getBeneficiaryById(beneficiaryId)
        .then(response => {
          let country = countries.find(item => item.countryCode == response.bankCountry);
          response.bankCountryCode = country.isoCodeAlpha2;
          this.setState({
            isLoading: false,
            selectedBeneficiary: response,
            isBeneficiaryModalVisible: true

          })
        })
        .catch(error => {
          this.setState({
            isLoading: false
          });
          displayGenericError(error);
        });

  };

  changeSelectedBeneficiary = (beneficiary) =>{
    this.setState({
      selectedBeneficiary: beneficiary
    })
  }

  render() {
    const intl = this.props.useIntl;
    let currentUser = this.props.currentCustomer;
    let isPartner = null;
    if (currentUser && currentUser.customerTierName && currentUser.customerTierName.includes('PARTNER')) {
        isPartner=true;
    }
    let sortDirections = this.props.sortType;
    let columns = [
      {
        title: intl.formatMessage({id: "app.table.beneficiariestable.beneficiaryname"}),
        width: 200,
        dataIndex: "fullName",
        key: "fullName",
        onHeaderCell:(col) =>{
          let sortType = sortDirections;
          return {
            onClick:(e)=>{
              this.props.changeSortType();
            }
          }
        },
        sorter: (a, b) => null,
        sortDirections: sortDirections
      },
      //{ title: "Email", width: 200, dataIndex: "email", key: "email"},
      {
        title: intl.formatMessage({id: "app.table.beneficiariestable.bankcountry"}),
        width: 200,
        dataIndex: "bankCountryName",
        key: "bankCountryName"
      },
      {
        title: intl.formatMessage({id: "app.table.beneficiariestable.bankname"}),
        width: 200,
        dataIndex: "bankName",
        key: "bankName"
      },
      {
        title: intl.formatMessage({id: "app.table.beneficiariestable.bankaccount"}),
        width: 200,
        dataIndex: "accountNumber",
        key: "accountNumber"
      },
      (this.props.currentCustomer.enableVaLegs && this.props.currentCustomer.enableVaLegs.includes("BENEFICIARY")) ? {
        title: intl.formatMessage({id: "app.common.virtualaccount"}),
        width: 200,
        dataIndex: "virtualAccounts",
        key: "virtualAccounts",
        render: virtualAccounts => {
          if(!virtualAccounts || virtualAccounts.length == 0) {
            return (<><div></div></>)
          } else  {
            let result = [];
            virtualAccounts.map(item => {
              
              let location = '';
              if(item.virtualAccountChannelCode=='DBS_HK' ) {
                location ="(HK)"
              } else if (item.virtualAccountChannelCode=='DBS_SG') {
                location ="(SG)"
              } else if (item.virtualAccountChannelCode=='SAHABAT_SAMPOERNA') {
                location ="(ID)"  
              } else if (item.virtualAccountChannelCode=='FLASH_FX') {
                location ="(AU)"  
              }  

              if (item.virtualAccountStatus === 'UNVERIFIED') {
                result.push(<div>{item.virtualAccountStatus}</div>);
              } else {
                result.push(<div>{item.virtualAccountNumber} {location}</div>);
              }
            })
            return (<>{result}</>);
          }
        }
      } : {width: 0},

    ];

    let columnsPartner = [
      {
        title: intl.formatMessage({id: "app.table.beneficiariestable.beneficiaryname"}),
        width: 200,
        dataIndex: "fullName",
        key: "fullName",
        onHeaderCell:(col) =>{
          let sortType = sortDirections;
          return {
            onClick:(e)=>{
              this.props.changeSortType();
            }
          }
        },
        sorter: (a, b) => null,
        sortDirections: sortDirections
      },
      {
        title: intl.formatMessage({id: "app.table.beneficiariestable.bankcountry"}),
        width: 200,
        dataIndex: "bankCountryName",
        key: "bankCountryName"
      },
      {
        title: intl.formatMessage({id: "app.table.beneficiariestable.bankname"}),
        width: 200,
        dataIndex: "bankName",
        key: "bankName"
      },
      {
        title: intl.formatMessage({id: "app.table.beneficiariestable.bankaccount"}),
        width: 200,
        dataIndex: "accountNumber",
        key: "accountNumber"
      },
      (this.props.currentCustomer.enableVaLegs && this.props.currentCustomer.enableVaLegs.includes("BENEFICIARY")) ? {
        title: intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccount"}),
        width: 200,
        dataIndex: "virtualAccounts",
        key: "virtualAccounts",
        render: virtualAccounts => {
          if(!virtualAccounts || virtualAccounts.length == 0) {
            return (<><div></div></>)
          } else  {
            let result = [];
            virtualAccounts.map(item => {

              let location = '';
              if(item.virtualAccountChannelCode=='DBS_HK' ) {
                location ="(HK)"
              } else if (item.virtualAccountChannelCode=='DBS_SG') {
                location ="(SG)"
              } else if (item.virtualAccountChannelCode=='SAHABAT_SAMPOERNA') {
                location ="(ID)"  
              } else if (item.virtualAccountChannelCode=='FLASH_FX') {
                location ="(AU)"  
              }  

              if (item.virtualAccountStatus === 'UNVERIFIED') {
                result.push(<div>{item.virtualAccountStatus}</div>);
              } else {
                result.push(<div>{item.virtualAccountNumber} {location}</div>);
              }
            })
            return (<>{result}</>);
          }
        }
      } : {width: 0},
      {
        title: intl.formatMessage({id: "app.table.beneficiariestable.sender"}),
        width: 200,
        dataIndex: "originators",
        key: "originators",
        render: originators => {
          let displayNameArr = [];
          if (originators && originators.length > 0) {
            let displayName = "";
            for (let originator of originators) {
              if (originator.originatorType === 'CORPORATE') {
                displayName = originator.businessName;
              } else if (originator.originatorType === 'INDIVIDUAL') {
                displayName = originator.lastName + "," + originator.firstName;
              }
              displayNameArr.push(displayName);
            }
            return (<div> {displayNameArr.map(item => {
                return (
                  <Tag>{item}</Tag>
                )
            })} </div>)
          }
          return null;
        }
      }
    ];

    const isMobile = this.state.width <= 767;
    if (isMobile) {
      columns = [
        {
          title: intl.formatMessage({id: "app.table.beneficiariestable.name"}),
          dataIndex: "fullName",
          key: "fullName"
        },
        {
          title: intl.formatMessage({id: "app.table.beneficiariestable.bank"}),
          dataIndex: "bankName",
          key: "bankName"
        },
        {
          title: intl.formatMessage({id: "app.table.beneficiariestable.account"}),
          dataIndex: "accountNumber",
          key: "accountNumber"
        }
      ];
    }
    const { data } = this.props;
    return (
      <div className={"manage-beneficiary-page"}>
        <BeneficiaryModal
          visible={this.state.isBeneficiaryModalVisible}
          onCompleted={this.submitBeneficiary}
          industries={this.state.industries}
          selectedBeneficiary={this.state.selectedBeneficiary}
          onCancel={this.closeBeneficiaryModal}
          changeSelectedBeneficiary={(beneficiary) => this.changeSelectedBeneficiary(beneficiary)}
          currentCustomer={this.props.currentCustomer}

        />

        {data && data.length > 0 && (
          <>
            <div className={"headline-page"} style={{justifyContent:'space-between'}}>
              <BeneficiarySelectionComponent onChange={e=>{}}
                                             onSelected={beneficiary => this.props.onBeneficiarySearch(beneficiary)}
                                             onClear={() => {
                                               this.props.onRefresh(1);
                                             }}/>
              {(this.props.currentUser && !this.props.currentUser.role.readOnly) && (
              <Button
                htmlType={"button"}
                type="primary"
                onClick={this.onAddBeneficiaryClicked}
              >
              <FormattedMessage id="app.table.beneficiariestable.addnewbeneficiary"/>
              </Button>)}
            </div>
            <Table
              expandIconAsCell={false}
              expandIconColumnIndex={-1}
              expandedRowKeys={this.state.expandedRowKeys}
              className="bp-table bp-expandable-table beneficiaries-table"
              pagination={this.props.pagination}
              onChange={(pagination, filters, sorter, extra) => this.props.onChangePage(pagination, filters, sorter, ['changePage'])}
              expandedRowRender={(beneficiary,idx,indent,expanded) => {
                let industries = this.state.industries;
                return (
                    <BeneficiaryInformationPanel
                        {...this.props}
                        beneficiary={beneficiary}
                        industries={industries}
                        nationalities={this.state.nationalities}
                        currentCustomer={this.props.currentCustomer}
                        relations={this.state.relations}
                        countries={this.state.countries}
                        hkSourceAccountCurrency={this.state.hkSourceAccountCurrency}
                        edit={this.editBeneficiaryClicked}
                        idxOfCurrentBene={idx}
                        updateBeneficiary={(idx,newBene) => this.props.updateBeneficiary(idx,newBene)}
                    />
                );
              }
              }
              columns={isPartner ? columnsPartner : columns}
              onRowClick={this.onRowClicked}
              dataSource={this.props.data}
              onRow={beneficiary => {
                return (
                  this.state.expandedRowKeys.includes(beneficiary.id) && {
                    className: "expanded-row"
                  }
                );
              }}
              loading={this.props.isLoading}
              rowKey="id"
            />
          </>
        )}
        {data && data.length === 0 && (
          <div className="beneficiaries-table-empty-wrapper">
            <EmptyIcon />
            <div className="beneficiaries-table-empty-desc">
              <FormattedMessage id="app.message.beneficiariestable.donthavebeneficiary"/>
            </div>
            <div className="beneficiaries-table-empty-desc">
              <FormattedMessage id="app.message.beneficiariestable.startaddingbeneficiary"/>
            </div>
            {this.props.currentUser && !this.props.currentUser.role.readOnly &&
            <Button
                htmlType={"button"}
                type="primary"
                className="beneficiaries-table-add"
                onClick={this.onAddBeneficiaryClicked}
            >
              <FormattedMessage id="app.table.beneficiariestable.addnewbeneficiary"/>
            </Button>}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state =>{
    return {
      currentUser: state.user.currentUser
    }
}

const mapDispatchToProps = dispatch =>{

}

export default withRouter(
    connect(mapStateToProps,mapDispatchToProps) (
    withUseIntl(BeneficiariesTable)));